export const howItWorksPageContent = {
  howItWorks: {
    id: 'how-it-works',
    title: 'How it works',
    subtitle: '',
    content: [
      'Eat at Zizzi and show your ID to earn Zs.',
      'Swap Zs for tasty Perkz',
      'Use your Perkz to get free food!',
    ],
  },
};
